module.exports = __webpack_public_path__ + "static/media/menu_open.d6fb2017.svg";